import { datatype, filtertype, queryInput } from 'API';
import { useCampaignContext } from 'context/CampaignContext';
import { useEffect, useState } from 'react';

export const useGetMainTotalQuery = (
  mainQuery: queryInput | undefined,
  which: string,
  hideTotal: boolean = false,
): readonly [queryInput | undefined] => {
  const { REACT_APP_AGENCY } = process.env;
  const { activeCampaign } = useCampaignContext();
  const [mainTotalQuery, setMainTotalQuery] = useState<queryInput>();

  useEffect(() => {
    if (mainQuery) {
      const isFacebook = mainQuery.views[0]?.viewName.includes('facebook') ? true : false;
      const isSnapchat = mainQuery.views[0]?.viewName.includes('snapchat') ? true : false;
      const isAdform = mainQuery.views[0]?.viewName.includes('adform') ? true : false;
      const isDV360 = mainQuery.views[0]?.viewName.includes('dv360') ? true : false;

      const dimMain = [
        {
          column: 'client_code',
          name: 'campaign_id',
          hidden: false,
          id: 'pero',
        },
      ];
      const dimCC = [
        {
          column: 'client_code',
          name: 'campaign_id',
          hidden: false,
          id: 'pero',
        },
        {
          column: isFacebook
            ? 'conversion_name'
            : isAdform
              ? 'filter_name'
              : isDV360
                ? 'floodlight_activity_name'
                : 'activity',
          // column: 'conversion_name',
          name: 'CC_name',
          hidden: false,
          id: 'CC_name',
        },
      ];

      const benchmarkDim = [
        {
          column: 'client_code',
          name: 'client_code',
          hidden: false,
          id: 'pero',
        },
      ];

      const totalQuery = structuredClone(mainQuery);
      totalQuery.query.detailedDimensions?.forEach((element: any) => {
        const filteredOrder = totalQuery.query.orderBy?.filter((remove: any) => remove !== element.id);
        totalQuery.query.orderBy = filteredOrder;
      });
      totalQuery.query.detailedDimensions = which === 'MAIN' ? dimMain : which === 'BENCHMARK' ? benchmarkDim : dimCC;
      if (totalQuery.query.detailedDimensions[0]?.id) {
        totalQuery.query.orderBy?.unshift(totalQuery.query.detailedDimensions[0].id);
      }
      totalQuery.query.metrics = totalQuery.query.metrics?.map((element: any) =>
        element.column.endsWith('reach') && (isFacebook || isSnapchat || isDV360)
          ? { ...element, column: 'campaign_mapping_reach' }
          : element,
      );
      // console.log("PEDERICA", totalQuery)
      if (mainQuery.query.metrics?.some((el: any) => el.column.endsWith('reach') && (isFacebook || isSnapchat || isDV360))) {
        if (mainQuery.query.filters?.some((el: any) => el.column !== 'campaign_id')) {
          totalQuery.query.nullColumns = ['campaign_mapping_reach'];
        }
        if (
          !totalQuery.views.some(
            (el: any) => el.viewName === `fozzie_facebook_frequency_campaign_${REACT_APP_AGENCY}`,
          ) &&
          isFacebook
        ) {
          totalQuery.views.push({
            viewName: `fozzie_facebook_frequency_campaign_${REACT_APP_AGENCY}`,
            database:
              activeCampaign?.ClientCountry === 'DK'
                ? 'data_lake_denmark'
                : activeCampaign?.ClientCountry === 'SE'
                  ? 'data_lake_sweden'
                  : activeCampaign?.ClientCountry === 'FI'
                    ? 'data_lake_finland'
                    : 'data_lake_norway',
          });
        }
      }

      totalQuery.query.orderBy =
        which === 'MAIN'
          ? (totalQuery.query.orderBy ?? [])
          : which === 'BENCHMARK'
            ? [...(totalQuery.query.calculatedMetrics?.map((m) => m?.id as string) ?? []), 'pero']
            : [...(totalQuery.query.orderBy ?? []), 'CC_name'];
      totalQuery.query.calculatedMetrics = totalQuery.query.calculatedMetrics?.map((element: any) =>
        element.query.includes('/MAX')
          ? {
              ...element,
              query: element.query.slice(0, element.query.indexOf('/')).concat('/MAX(#campaign_mapping_reach)'),
            }
          : element,
      );
      if (mainQuery.query.calculatedMetrics?.some((el: any) => el.query.includes('/MAX'))) {
        if (mainQuery.query.filters?.some((el: any) => el.column !== 'campaign_id')) {
          totalQuery.query.nullColumns = ['campaign_mapping_reach'];
        }
        if (
          !totalQuery.views.some(
            (el: any) => el.viewName === `fozzie_facebook_frequency_campaign_${REACT_APP_AGENCY}`,
          ) &&
          isFacebook
        ) {
          totalQuery.views.push({
            viewName: `fozzie_facebook_frequency_campaign_${REACT_APP_AGENCY}`,
            database:
              activeCampaign?.ClientCountry === 'DK'
                ? 'data_lake_denmark'
                : activeCampaign?.ClientCountry === 'SE'
                  ? 'data_lake_sweden'
                  : activeCampaign?.ClientCountry === 'FI'
                    ? 'data_lake_finland'
                    : 'data_lake_norway',
          });
        }
      }
      if (
        totalQuery.query.filters?.some(
          (el) => el?.column === 'campaign_id' && (el?.filter as any)?.list && (el?.filter as any)?.list?.length > 1,
        )
      ) {
        totalQuery.query.nullColumns = ['campaign_mapping_reach'];
      }

      // Add all metrics and calculated metrics to nullColumns when hideTotal is enabled
      if (hideTotal && mainQuery.query.groupFilters && mainQuery.query.groupFilters.length > 0) {
        // Set groupFilters when hideTotal is enabled - this will make the query return no results
        // Create groupFilters array if it doesn't exist
        if (!totalQuery.query.groupFilters) {
          totalQuery.query.groupFilters = [];
        }
        // Add or update the first groupFilter with an impossible condition
        if (totalQuery.query.groupFilters.length === 0) {
          totalQuery.query.groupFilters.push({
            column: 'client_code',
            filter: {
              datatype: datatype.NUMBER,
              filtertype: filtertype.LT,
              value: '-1',
            },
          });
        } else if (totalQuery.query.groupFilters[0]) {
          totalQuery.query.groupFilters[0].filter = {
            datatype: datatype.NUMBER,
            filtertype: filtertype.LT,
            value: '-1',
          };
        }
      }

      // Remove groupFilters for benchmark queries
      if (which === 'BENCHMARK' || which === 'CC') {
        delete totalQuery.query.groupFilters;
      }

      console.log('TOTAL QUERY FOR', hideTotal, which, totalQuery);
      setMainTotalQuery(totalQuery);
    }
  }, [REACT_APP_AGENCY, activeCampaign?.ClientCountry, mainQuery, which, hideTotal]);

  return [mainTotalQuery];
};
